import City from 'Modules/City';
if (!theme_vars.disableCityCheck) {
  City.getCurrent();
  City.askForCurrent();
}
